const layers = [
    {
      "type": "overlayers",
      "name": "Sobreposições",
      "visible": true,


      "layers": [
        {
          "id": 1737,
          "name": "Estações",
          "url": "https://produtos.simepar.br/geosimepar/tornado/wms?",
          "url_params": {
            "LAYERS": "tornado:estacao_uf",
            "STYLES": "infohidro-stations",
            "cql_filter": "(estcodigo in (25484904,25364907,25594916,25604939,25584963,25514914,25454912,25424938,25474883,23335184,25484918,25324916,25484919,23165078,25514921,25544941,23445096,25235096,25395143,25465053,26085307,26155302,25454904) or estorgao = 7) AND ufsigla in ('PR')"
          },
          "layer_class": "ol.layer.Tile",
          "layer_type": "ol.source.TileWMS",
          "event_params": {
            "type": "click",
          },
          "tooltip_params": {
            "KEYS": [
              '{"key": "estnome,munnome", "label_title": ""}',
              '{"key": "esttipo", "label": "Tipo"}',
              '{"key": "estorgao", "label": "Órgão"}',
            ],
            "FORMAT": "ETE {0} - {1} - {2}",
          },
          "property_params": {
            "opacity": 0.9,
            "visible": true,
            "zindex": 2
          },
        },
      ]
    }
];

export default layers;
